import { createContext, useContext, useState, useCallback } from 'react';

const AdminAuthContext = createContext(null);

const SESSION_KEY = 'lg_admin_auth';

export function AdminAuthProvider({ children }) {
  const [secret, setSecret] = useState(() => sessionStorage.getItem(SESSION_KEY) || '');
  const [isAuth, setIsAuth]   = useState(() => !!sessionStorage.getItem(SESSION_KEY));

  const login = useCallback((value) => {
    sessionStorage.setItem(SESSION_KEY, value);
    setSecret(value);
    setIsAuth(true);
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem(SESSION_KEY);
    setSecret('');
    setIsAuth(false);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ isAuth, secret, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be inside AdminAuthProvider');
  return ctx;
};
